import React, { createContext, useContext, useState, useEffect } from 'react';
import { API } from '../lib/axios';

export const MainCategoryContext = createContext();

export const MainCategoryProvider = ({ children }) => {
    const [mainCategories, setMainCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMainCategories = async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await API.get("/main-categories");
            setMainCategories(res.data || []);
        } catch (error) {
            setError("Failed to load categories");
            // Set empty array as fallback
            setMainCategories([]);
        } finally {
            setLoading(false);
        }
    };

    const getMainCategoryBySlug = (slug) => {
        return mainCategories.find(category => category.slug === slug);
    };

    const getMainCategoryById = (id) => {
        return mainCategories.find(category => category.id === id);
    };

    // Defer main categories loading to improve initial page render
    // Categories are not critical for product pages
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchMainCategories();
        }, 200); // Defer by 200ms to allow critical content to load first

        return () => clearTimeout(timer);
    }, []);

    return (
        <MainCategoryContext.Provider value={{ 
            mainCategories, 
            setMainCategories, 
            loading, 
            setLoading, 
            error, 
            setError,
            fetchMainCategories,
            getMainCategoryBySlug,
            getMainCategoryById
        }}>
            {children}
        </MainCategoryContext.Provider>
    );
};

// Custom hook
export const useMainCategories = () => useContext(MainCategoryContext);
